<template>
  <el-row style="width: 100%;background-color: #eaf4f7;margin-top: 10px;">
    <el-menu ref="footerMenu" style="width: 94%;margin: 20px 0 0 3%;text-align: left;border-right: 0;border-top: 1px solid #aaa;"
             unique-opened background-color="#eaf4f7" text-color="#303133" active-text-color="#303133">
      <el-submenu v-for="(item, i) in menuList" :key="i" :index="item.id" class="footer-submenu-class">
        <span slot="title" style="font-weight: bold;font-size: 16px;">{{item.name}}</span>
        <el-menu-item v-for="(itemItem, j) in item.data" :key="j" :index="itemItem.id" class="footer-menu-item" @click="clickMenu(i, j)">
          {{itemItem.name}}
        </el-menu-item>
      </el-submenu>
    </el-menu>
    <el-row style="display: flex;height: 40px;width: 94%;margin-left: 3%;margin-top: 50px;justify-content: center;">
      <div v-for="(item, i) in conList" :key="i">
        <el-tooltip popper-class="qrcode-tooltip" effect="light" placement="top" :manual="true" v-model="item.show">
          <div style="width: 180px;height: 210px;" slot="content">
            <div style="width: 100%;height: 26px;display: flex;background-color: #f3f3f3;color: #777;">
              <div style="width: 70%;margin-left: 15%;line-height: 26px;text-align: center;">{{item.title}}</div>
              <div style="width: 15%;height: 26px;display: flex;align-items: center;justify-content: center;" @click="closeTooltip(i)">
                <i class="el-icon-close" style="font-size: 20px;" />
              </div>
            </div>
            <div style="width: 138px;margin-left: 21px;">
              <div :style="{'background-image': 'url(' + item.img + ')'}" class="qrcode-img"></div>
              <div style="width: 122px;margin-left: 8px;height: 40px;line-height: 20px;">{{item.remark}}</div>
            </div>
          </div>
          <i :class="item.icon" style="margin: 0 20px 0 20px;font-size: 36px;color: #666;" @click="clickIcon(i)" />
        </el-tooltip>
      </div>
    </el-row>
    <el-row style="width: 94%;margin-left: 3%;height: 72px;margin-top: 10px;font-size: 14px;line-height: 28px;color: #696969;">
      <el-row>Copyright©武汉瑜岿科技有限公司版权所有</el-row>
      <el-row @click.native="toIcpAddr">鄂ICP备2022007980号-1</el-row>
    </el-row>
<!--    <el-row style="width: 68%;margin-left: 16%;height: calc(100% - 100px);border-bottom: 1px solid #000000;display: flex;">-->
<!--      <el-col style="width: 39%;height: 100%;text-align: left;color: #000000;margin-left: 1%;">-->
<!--        <el-row style="width: 100%;height: 40px;line-height: 40px;font-size: 28px;margin-top: 44px;">武汉瑜岿科技有限公司</el-row>-->
<!--        <el-row style="width: 100%;height: 36px;line-height: 36px;font-size: 18px;">WUHAN YUKUI TECHNOLOGY CO.,LTD.</el-row>-->
<!--        <el-row style="width: 100%;height: 26px;line-height: 26px;font-size: 14px;color: #5e5e5e;margin-top: 26px;">电话：17720560059</el-row>-->
<!--        <el-row style="width: 100%;height: 26px;line-height: 26px;font-size: 14px;color: #5e5e5e;">备用：13733490447</el-row>-->
<!--        <el-row style="width: 100%;height: 26px;line-height: 26px;font-size: 14px;color: #5e5e5e;">邮箱：yukuitech@163.com</el-row>-->
<!--        <el-row style="width: 100%;height: 26px;line-height: 26px;font-size: 14px;color: #5e5e5e;">地址：湖北省武汉市武昌区中北路九万里武昌人才基地</el-row>-->
<!--      </el-col>-->
<!--      <el-col style="width: calc(20% - 40px);margin-left: 80px;margin-top: 64px;color: #696969;font-size: 16px;font-weight: bold;text-align: left;">-->
<!--        <el-row style="width: 100%;height: 36px;margin-bottom: 24px;cursor: pointer;" @click.native="routeChange('/software', '311')">软件产品</el-row>-->
<!--        <el-row style="width: 100%;height: 36px;margin-bottom: 24px;cursor: pointer;" @click.native="routeChange('/hardware', '321')">硬件产品</el-row>-->
<!--        <el-row style="width: 100%;height: 36px;margin-bottom: 24px;cursor: pointer;" @click.native="routeChange('/solution', '411')">解决方案</el-row>-->
<!--      </el-col>-->
<!--      <el-col style="width: 10%;margin-top: 64px;color: #696969;font-size: 16px;font-weight: bold;text-align: left;">-->
<!--        <el-row style="width: 100%;height: 36px;margin-bottom: 24px;cursor: pointer;" @click.native="routeChange('/short_introduce')">走进瑜岿</el-row>-->
<!--        <el-row style="width: 100%;height: 36px;margin-bottom: 24px;cursor: pointer;" @click.native="routeChange('/news')">新闻资讯</el-row>-->
<!--&lt;!&ndash;        <el-row style="width: 100%;height: 36px;margin-bottom: 24px;cursor: pointer;">加入瑜岿</el-row>&ndash;&gt;-->
<!--&lt;!&ndash;        <el-row style="width: 100%;height: 36px;margin-bottom: 24px;cursor: pointer;">联系我们</el-row>&ndash;&gt;-->
<!--      </el-col>-->
<!--      <el-col style="width: calc(20% - 40px);margin-top:56px;color: #5e5e5e;font-size: 14px;">-->
<!--        <el-row class="qrcode-img"></el-row>-->
<!--        <el-row style="line-height: 30px;">扫码关注</el-row>-->
<!--        <el-row style="line-height: 20px;">武汉瑜岿科技有限公司</el-row>-->
<!--      </el-col>-->
<!--    </el-row>-->
<!--    <el-row style="width: 70%;margin-left: 10%;height: 74px;margin-top: 26px;font-size: 14px;color: #696969;">-->
<!--      Copyright©武汉瑜岿科技有限公司版权所有-->
<!--      <span style="cursor: pointer;margin-left: 10px;" @click.native="toIcpAddr">鄂ICP备2022007980号-1</span>-->
<!--    </el-row>-->
  </el-row>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      conList: [
        { show: false, icon: 'yk-icon-weixin', img: require('../assets/img/weixin_qrcode.jpg'), title: '官网微信公众号', remark: '微信中识别二维码或搜索" 瑜岿科技 "公众号'},
        { show: false, icon: 'yk-icon-douyin', img: require('../assets/img/douyin_qrcode.jpg'), title: '官方抖音号', remark: '抖音中识别二维码或搜索" 瑜岿科技 "账号' }
      ],
      menuList: [
        {id: '2', name: '走进瑜岿', data: [{id: '21', name: '公司简介', component: '/short_introduce'}, {id: '22', name: '企业文化', component: '/culture'}, {id: '23', name: '资质荣誉', component: '/honor'}, {id: '24', name: '核心团队', component: '/team'}]},
        {id: '7', name: '新闻资讯', component: '/news', data: [{id: '71', name: '公司新闻', param: '71'}, {id: '72', name: '行业动态', param: '72'}]},
        {id: '31', name: '软件产品', component: '/software', data: [{id: '311', name: '综合能源管理系统', param: '311'}, {id: '312', name: '分布式光伏运维系统', param: '312'}, {id: '313', name: '智慧配电系统', param: '313'}, {id: '314', name: '预付费系统', param: '314'}, {id: '315', name: '电气火灾监测系统', param: '315'}]},
        {id: '32', name: '硬件产品', component: '/hardware', data: [{id: '321', name: '仪表类', param: '321'}, {id: '322', name: '传感类', param: '322'}, {id: '323', name: '智能类', param: '323'}, {id: '324', name: '智能类', param: '324'}]},
      ]
    }
  },
  methods: {
    toIcpAddr() {
      window.open('https://beian.miit.gov.cn/', '_blank')
    },
    routeChange(val, page) {
      if (this.$route.path !== val) {
        if (page) {
          this.$router.push({path: val, query: {page: page}})
        } else {
          this.$router.push(val)
        }
      } else {
        document.documentElement.scrollTop = 0
        location.reload()
      }
    },
    toOutside(url) {
      window.open(url, '_blank')
    },
    clickIcon(i) {
      this.conList.forEach((item, index) => {
        if (index !== i) {
          item.show = false
        }
      })
      this.conList[i].show = true
    },
    closeTooltip(i) {
      this.conList[i].show = false
    },
    clickMenu(i, j) {
      this.$refs.footerMenu.close(this.menuList[i].id)
      if (this.menuList[i].data[j].param) {
        if (this.$route.path === this.menuList[i].component && this.$route.query.page === this.menuList[i].data[j].param) {
          document.documentElement.scrollTop = 0
          location.reload()
        } else {
          this.$router.push({path: this.menuList[i].component, query: {'page': this.menuList[i].data[j].param}})
        }
      } else {
        if (this.$route.path === this.menuList[i].data[j].component) {
          document.documentElement.scrollTop = 0
          location.reload()
        } else {
          this.$router.push({path: this.menuList[i].data[j].component})
        }
      }
    }
  }
}
</script>

<style>
  .qrcode-tooltip {
    padding: 0 !important;
  }
  .footer-submenu-class .el-submenu__title {
    padding-left: 5px !important;
    background-color: #eaf4f7 !important;
    border-bottom: 1px solid #aaa !important;
  }
  .footer-submenu-class .el-submenu__title:hover {
    background-color: #eaf4f7 !important;
  }
  .footer-menu-item {
    font-size: 14px;
    padding-left: 0 !important;
    margin-left: 10px !important;
    background-color: #eaf4f7 !important;
    border-bottom: 1px solid #aaa !important;
  }
</style>
<style scoped>
  .qrcode-img {
    width: 138px;
    height: 138px;
    background-size: contain;
    background-repeat: no-repeat;
  }
</style>



// WEBPACK FOOTER //
// src/components/FooterPage.vue